/*
<ai_context>
This client page provides the login form from Clerk.
</ai_context>
*/

"use client"

import { SignIn } from "@clerk/nextjs"
import { useSearchParams } from "next/navigation"

export default function LoginPage() {
  const searchParams = useSearchParams()

  // Extract the original destination URL if it exists
  const redirectUrl = searchParams.get("redirect_url")
  // Use conversations (plural) to match the public routes defined in middleware
  const defaultRedirectUrl = "/"

  // Determine where to redirect after login
  const finalRedirectUrl =
    redirectUrl && !redirectUrl.includes("/login")
      ? redirectUrl
      : defaultRedirectUrl

  return (
    <SignIn
      forceRedirectUrl={finalRedirectUrl}
    />
  )
}
